mutation CreateSmsBroadcast {
    smsBroadcastCreate {
        broadcast {
            id
            name
            htmlUrl
            htmlUrlPath
            edition {
                id
                name
                htmlUrl
                htmlUrlPath
            }
        }
    }
}
